import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { defineMessage, useIntl } from 'react-intl';

import { useSDK } from '../../app';
import { styled } from '../../styled';
import type { Theme } from '../../theme/interface/detailed';
import { useSanitize } from '../../utils/useSanitize';

type Interface = { className: string };

const ratingLabelMsg = defineMessage({ id: 'rating.label', defaultMessage: 'Пожалуйста, оцените работу оператора' });

const Component = observer(({ className }: Interface): ReactElement => {
	const { welcomeDataStore } = useSDK();
	const { formatMessage } = useIntl();
	const html = useSanitize(welcomeDataStore.data?.showcase.rateText || '');

	if (!html) {
		return <div className={className}>{formatMessage(ratingLabelMsg)}</div>;
	}

	return <div dangerouslySetInnerHTML={html} className={className} />;
});

const styles = css`
	text-align: center;
`;

const RatingLabel = styled(Component)(
	({
		theme: {
			ratingField: {
				text: { ratingLabel },
			},
		},
	}: {
		theme: Theme;
	}) => ratingLabel,
	styles
);

export { RatingLabel };
